import { render, staticRenderFns } from "./DeclarationISSInformations.vue?vue&type=template&id=397eda3a&scoped=true"
import script from "./DeclarationISSInformations.vue?vue&type=script&lang=js"
export * from "./DeclarationISSInformations.vue?vue&type=script&lang=js"
import style0 from "./DeclarationISSInformations.vue?vue&type=style&index=0&id=397eda3a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "397eda3a",
  null
  
)

export default component.exports